import React from "react";
import Contact from "../pages/Contact";
import classes from "./Request.module.css";
import Form from "./Form";

export default function Request() {
  return (
    <>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-10">
              <div className="section-title position-relative pb-3 mb-3">
                <h1 className="mb-0">
                  Need A Free Quote? Please Feel Free to Contact Us
                </h1>
              </div>
              {/* <div className="row gx-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-4 btn btn-outline-dark">
                    <i className="fa fa-reply text-primary me-4"></i>
                    Reply within 24 hours
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-4 btn btn-outline-danger">
                    <i className="fa fa-phone-alt text-primary me-4"></i>24 hrs
                    telephone support
                  </h5>
                </div>
              </div> */}
              <Form />
              <div
                className="d-flex align-items-center mt-1 wow zoomIn"
                data-wow-delay="0.6s"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
